import React, { useEffect, useState } from 'react';
import '../css/FileBrowser.css';

type Entry = {
  name: string;
  is_dir: boolean;
};

type Props = {
  apipath?: string;
};

const FileBrowser: React.FC<Props> = ({ apipath = '' }) => {
  const [entries, setEntries] = useState<Entry[]>([]);
  const [loading, setLoading] = useState(true);
  const [path, setPath] = useState('/');

  useEffect(() => {
    const loadDir = async () => {
      try {
        setLoading(true);
        const normalizedPath = path.startsWith('/') ? path.slice(1) : path;
        const response = await fetch(
          `${apipath}/list?path=${encodeURIComponent(normalizedPath)}`
        );
        const data = await response.json();

        if (data.entries) {
          const sorted = [...data.entries].sort((a, b) => {
            if (a.is_dir && !b.is_dir) return -1;
            if (!a.is_dir && b.is_dir) return 1;
            return a.name.localeCompare(b.name);
          });
          setEntries(sorted);
        } else {
          console.error('No entries found', data);
        }
      } catch (err) {
        console.error('Error fetching directory:', err);
      } finally {
        setLoading(false);
      }
    };

    loadDir();
  }, [path]);

  const handleClick = (entry: Entry) => {
    const newPath = path === '/' ? `${entry.name}` : `${path}/${entry.name}`;
    if (entry.is_dir) {
      setPath(newPath);
    } else {
      window.open(
        `${apipath}/download?path=${encodeURIComponent(newPath)}`,
        '_blank'
      );
    }
  };

  const handleBack = () => {
    const parts = path.split('/').filter(Boolean);
    parts.pop(); // remove last segment
    const newPath = parts.join('/');
    setPath(newPath); // '' is root, others are relative
  };

  return (
    <div style={{ marginTop: '6rem' }}>
      <h4>Browsing: {path}</h4>
      {path !== '/' && <button onClick={handleBack}>🔙 Back</button>}
      {loading ? (
        <p>Loading...</p>
      ) : (
        <ul className="file-browse">
          {entries.map((entry) => (
            <li key={entry.name}>
              <button
                onClick={() => handleClick(entry)}
                className="file-browse-item"
              >
                {entry.is_dir ? '📁' : '📄'} {entry.name}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default FileBrowser;
